<ng-container *transloco="let t">
  <!-- Component -->
  <ng-container *ngIf="loading !== true">
    <button
      #sortFilterButton
      (click)="onOpenFilterByPhoneFilterss()"
      class="popsy-filter-by-phone-filters flex flex-row align-center"
      [class.justify-start]="compact !== true"
      [class.justify-center]="compact === true"
      [class.compact]="compact === true">
      <div class="flex flex align-start justify-between full-width">
        <span>{{ t('sidebar_filter_title') }}</span>
        <span class="fixed-space-4" aria-hidden="true"></span>
        <popsy-icon-align-right class="icon bigger fill-gray-01"></popsy-icon-align-right>
      </div>

      <ng-container *ngIf="compact !== true">
        <span class="fixed-space-4" aria-hidden="true"></span>

        <div class="flex flex-col align-center justify-center">
          <ng-container *ngIf="(open$ | async) !== true">
            <popsy-icon-arrow-down-1
              class="icon gray-01"
              aria-hidden="true"></popsy-icon-arrow-down-1>
          </ng-container>
          <ng-container *ngIf="(open$ | async) === true">
            <popsy-icon-arrow-up-1
              class="icon gray-01"
              aria-hidden="true"></popsy-icon-arrow-up-1>
          </ng-container>
        </div>
      </ng-container>
    </button>
  </ng-container>

  <!-- Placeholder -->
  <ng-container *ngIf="loading === true">
    <div
      class="skeleton popsy-filter-by-phone-filters"
      [class.compact]="compact"
      aria-hidden="true">
      <popsy-skeleton class="skeleton label"></popsy-skeleton>
      <popsy-skeleton class="field-skeleton"></popsy-skeleton>

      <div class="flex flex-col align-start justify-center full-width">
        <popsy-skeleton class="skeleton sort-title"></popsy-skeleton>
        <span class="fixed-space-4" aria-hidden="true"></span>
        <popsy-skeleton class="skeleton sort-value"></popsy-skeleton>
      </div>

      <span class="fixed-space-4" aria-hidden="true"></span>

      <div class="flex flex-col align-center justify-center">
        <popsy-skeleton class="skeleton icon"></popsy-skeleton>
      </div>
    </div>
  </ng-container>
</ng-container>
